import { render, staticRenderFns } from "./PendingDeliveriesPanel.vue?vue&type=template&id=00047b16&scoped=true"
import script from "./PendingDeliveriesPanel.vue?vue&type=script&lang=js"
export * from "./PendingDeliveriesPanel.vue?vue&type=script&lang=js"
import style0 from "./PendingDeliveriesPanel.vue?vue&type=style&index=0&id=00047b16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00047b16",
  null
  
)

export default component.exports